import React from 'react';
import { Skeleton, SkeletonProps } from '@mui/material';

interface SaralSkeletonProps extends Omit<SkeletonProps, 'sx'> {
  borderRadius?: number;
  bgColor?: string;
  sx?: SkeletonProps['sx'];
  marginBottom?: number;
}

const SaralSkeleton: React.FC<SaralSkeletonProps> = ({
  variant = 'rounded',
  borderRadius = 32,
  bgColor = 'var(--background-highlight)',
  marginBottom = 0,
  sx,
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <Skeleton
      variant={variant}
      sx={{
        bgcolor: bgColor,
        borderRadius: `${borderRadius}px`,
        marginBottom: `${marginBottom}px`,
        height: `${height}px`,
        width: `${width}px`,
        ...sx,
      }}
      {...props}
    />
  );
};

export default SaralSkeleton;
